import React from "react";
import {
  FaRobot,
  FaChartBar,
  FaUpload,
  FaFolderOpen,
  FaDatabase,
  FaFilePdf,
} from "react-icons/fa";
import { useAuth } from "react-oidc-context";
import { getPermissions } from "../utils/permissions";
import "../styles/WelcomeView.css";

const WelcomeView = ({ setView }) => {
  const auth = useAuth();

  const {
    canUpload,
    canViewFiles,
    canViewData,
    canViewReports,
    canViewDashboards,
    canUseBackstageAI,
  } = getPermissions(auth.user);

  return (
    <div className="welcome-view">
      <div className="welcome-hero">
        <p className="welcome-eyebrow">OCESA - GAIA</p>
        <h1>Bienvenido a GAIA</h1>
        <p>
          Consulta inteligencia del negocio, tableros ejecutivos y herramientas
          de análisis para dar seguimiento a eventos, audiencias, patrocinios y
          operación comercial.
        </p>
      </div>

      <div className="welcome-grid">
        {canViewDashboards && (
          <button
            className="welcome-card"
            onClick={() => setView("DashboardsView")}
          >
            <FaChartBar className="welcome-icon" />
            <h3>Tableros ejecutivos</h3>
            <p>
              Visualiza dashboards de QuickSight con indicadores clave del
              negocio.
            </p>
          </button>
        )}

        {canUseBackstageAI && (
          <button
            className="welcome-card"
            onClick={() => setView("chatInterface")}
          >
            <FaRobot className="welcome-icon" />
            <h3>Backstage AI</h3>
            <p>
              Haz preguntas, consulta información y obtén insights con lenguaje
              natural.
            </p>
          </button>
        )}

        {canUpload && (
          <button className="welcome-card" onClick={() => setView("upload")}>
            <FaUpload className="welcome-icon" />
            <h3>Subir archivos</h3>
            <p>Carga archivos operativos, reportes y documentos para análisis.</p>
          </button>
        )}

        {canViewFiles && (
          <button
            className="welcome-card"
            onClick={() => setView("FileExplorer")}
          >
            <FaFolderOpen className="welcome-icon" />
            <h3>Visualizar archivos</h3>
            <p>Explora archivos disponibles dentro del repositorio operativo.</p>
          </button>
        )}

        {canViewData && (
          <button className="welcome-card" onClick={() => setView("data")}>
            <FaDatabase className="welcome-icon" />
            <h3>Datos</h3>
            <p>Consulta vistas de datos y gobierno de información.</p>
          </button>
        )}

        {canViewReports && (
          <button
            className="welcome-card"
            onClick={() => setView("ReportsView")}
          >
            <FaFilePdf className="welcome-icon" />
            <h3>Reportes PDF</h3>
            <p>Consulta reportes ejecutivos y documentos históricos.</p>
          </button>
        )}
      </div>
    </div>
  );
};

export default WelcomeView;
